import { type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useMapLayout } from "./useMapLayout";
import { REGION_IDS } from "./constants";

interface MessagesProps {
  children: ReactNode;
}

/**
 * MapLayout.Messages - Portals content to the messages region (bottom-left).
 *
 * Use for:
 * - Instructional messages ("Click on map to place...")
 * - Toast notifications
 * - Status indicators ("Saving...", "Offline")
 */
export default function Messages({ children }: MessagesProps) {
  const { mounted } = useMapLayout();

  if (!mounted) return null;

  const target = document.getElementById(REGION_IDS.messages);
  if (!target) return null;

  return createPortal(<>{children}</>, target);
}
